var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4462 9.95009L27.2426 7L29.7057 7.79991L30.2339 11.8312L31.9175 13.0543L35.9175 12.3112L37.4392 14.4062L35.4944 17.9779L36.138 19.9575L39.8082 21.7049V24.2951L36.138 26.0425L35.4944 28.0221L37.4366 31.5938L35.9149 33.6888L31.9149 32.9457L30.2313 34.1688L29.7057 38.2001L27.2426 39L24.4462 36.0499H22.3646L19.5681 39L17.105 38.2001L16.5773 34.1688L14.8937 32.9457L10.8937 33.6888L9.37153 31.5938L11.3138 28.0221L10.6706 26.0425L7 24.2951V21.7049L10.6706 19.9575L11.3138 17.9779L9.37153 14.4062L10.8937 12.3112L14.8937 13.0543L16.5773 11.8312L17.105 7.79991L19.5681 7L22.3646 9.95009H24.4462ZM30.9192 23C30.9192 27.4184 27.3376 31 22.9192 31C18.5008 31 14.9192 27.4184 14.9192 23C14.9192 18.5816 18.5008 15 22.9192 15C27.3376 15 30.9192 18.5816 30.9192 23ZM22.9194 27.4449C25.3738 27.4449 27.3638 25.4548 27.3638 23.0004C27.3638 20.546 25.3738 18.556 22.9194 18.556C20.4649 18.556 18.4749 20.546 18.4749 23.0004C18.4749 25.4548 20.4649 27.4449 22.9194 27.4449Z",
    fill: "#003E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfig);
export default __webpack_public_path__ + "static/media/Config.edee6240329374e8de984fb0ae102cc9.svg";
export { ForwardRef as ReactComponent };